import {
  GA_LABEL2,
  GA_LABEL3,
  GA_SCREEN_NAME,
  SELECT_BY_WISHLINK_CATEGORY_RANKING,
} from "../../utils/constants";

export const getCustomParam = (queryParams) => {
  const entrypoint = queryParams.get("entrypoint");
  if (entrypoint === "COLLECTION") return GA_LABEL3.RECOMMENDED_COLLECTION;
  else if (entrypoint === "BANNER") return GA_LABEL3.CUSTOM_COLLECTION;
  else return "";
};

export const getLabel3 = (queryParams) => {
  const entrypoint = queryParams.get("entrypoint");
  if (entrypoint === "COLLECTION") return GA_LABEL3.RECOMMENDED_COLLECTION;
  else if (entrypoint === "BANNER") return GA_LABEL3.CUSTOM_COLLECTION;
  else return "";
};

/** SBWL Collections PLP: event_label=collection vs category_widget; label2=list of selected category widget labels OR commission/fallback string. */
export const getSbwlCollectionPlListingLabels = (
  filterOptionsSelected,
  collectionListingLabel2Fallback = "",
  queryParams,
  product
) => {
  const plpCollectionId = queryParams?.get("plpCollectionId");
  const catOpts = filterOptionsSelected?.[3]?.options ?? [];
  if (catOpts.length > 0) {
    const label2 = catOpts
      .map(
        (v) =>
          SELECT_BY_WISHLINK_CATEGORY_RANKING.find((c) => c.value === v)
            ?.label ?? String(v)
      )
      .join(", ");
    return { label: "category_widget", label2 };
  }
  if (plpCollectionId) {
    return { label: "collection", label2: collectionListingLabel2Fallback };
  }
  if (product) {
    return { label: product?.price, label2: collectionListingLabel2Fallback };
  }
  return {
    label: "pdp_similar_products",
    label2: collectionListingLabel2Fallback,
  };
};

/** Payload for PRODUCT_IMPRESSION / ProductCard-style click on SBWL grids (price commissioned into label3). */
export const buildSbwlProductListingGaDimensions = ({
  filterOptionsSelected,
  commissionStr,
  product,
  queryParams,
  getLabel3Fn = getLabel3,
}) => {
  const price = product?.price ?? "";
  const invOrEntry =
    product?.total_inventory > 0
      ? product.total_inventory
      : getLabel3Fn(queryParams);
  const listing = getSbwlCollectionPlListingLabels(
    filterOptionsSelected,
    commissionStr ?? "",
    queryParams,
    product
  );
  if (listing.label === "category_widget") {
    return {
      label: listing.label,
      label2: listing.label2,
      label3: `${price}|${commissionStr}|${invOrEntry}`,
    };
  }
  return {
    label: listing.label,
    label2: commissionStr ?? "",
    label3: `${price}|${invOrEntry}`,
  };
};

/** PDP add-to-cart label2: category_widget | collection | pdp_similar_products (PLP listing source). */
export const getPdpAddToCartLabel2 = ({
  queryParams,
  filterOptionsSelected,
  collectionId,
}) => {
  const fromNav = queryParams?.get("gaLabel2");
  if (fromNav) return fromNav;

  const catOpts = filterOptionsSelected?.[3]?.options ?? [];
  if (catOpts.length > 0) return "category_widget";

  if (queryParams?.get("plpCollectionId") || collectionId) {
    return GA_LABEL2.COLLECTION;
  }

  return "pdp_similar_products";
};

export const getSubCategory = (queryParams) => {
  const subcategoryId = queryParams.get("subcategoryId");
  if (subcategoryId) {
    return subcategoryId;
  }
  return "";
};

export const determinePLPSaveForLater = (queryParams) => {
  const entrypoint = queryParams.get("entrypoint");
  if (entrypoint === "CATEGORY") return GA_SCREEN_NAME.CATEGORY_PLP;
  else if (entrypoint === "BANNER" || entrypoint === "COLLECTION")
    return GA_SCREEN_NAME.COLLECTION_PLP;
  else if (entrypoint === "BRAND") return GA_SCREEN_NAME.BRAND_PLP;
  else if (entrypoint === "SEARCH") return GA_SCREEN_NAME.SEARCH_PLP;
  else return GA_SCREEN_NAME.SAVE_FOR_LATER_PLP;
};

export const determinePLPSourcing = (queryParams) => {
  const entrypoint = queryParams.get("entrypoint");
  if (entrypoint === "CATEGORY") return GA_SCREEN_NAME.CATEGORY_PLP;
  else if (entrypoint === "BANNER" || entrypoint === "COLLECTION")
    return GA_SCREEN_NAME.COLLECTION_PLP;
  else if (entrypoint === "BRAND") return GA_SCREEN_NAME.BRAND_PLP;
  else if (entrypoint === "SEARCH") return GA_SCREEN_NAME.SEARCH_PLP;
  else return GA_SCREEN_NAME.SOURCING;
};

export const determinePLPEmpty = (queryParams) => {
  const entrypoint = queryParams.get("entrypoint");
  if (entrypoint === "CATEGORY") return GA_SCREEN_NAME.CATEGORY_PLP;
  else if (entrypoint === "BANNER" || entrypoint === "COLLECTION")
    return GA_SCREEN_NAME.COLLECTION_PLP;
  else if (entrypoint === "BRAND") return GA_SCREEN_NAME.BRAND_PLP;
  else if (entrypoint === "SEARCH") return GA_SCREEN_NAME.SEARCH_PLP;
  else return "";
};

export const getVariantFromUrl = (location) => {
  const pathname = location?.pathname;
  if (pathname.startsWith("/brand-sourcing")) return "brand-sourcing";
  else return "sourcing";
};

export const getLabel = (searchParams, collectionDetails) => {
  const entrypoint = searchParams.get("entrypoint");
  if (entrypoint === "CATEGORY") return collectionDetails?.display_name;
  else if (entrypoint === "BRAND") return collectionDetails?.name;
  else if (entrypoint === "COLLECTION" || entrypoint === "BANNER")
    return collectionDetails?.title;
  else return "";
};
